import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function PaymentSuccessPage() {
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      console.warn("No session_id found in URL parameters.");
      navigate("/", { replace: true });
    }
  }, [sessionId, navigate]);

  // Optionally prevent flash of UI if redirecting
  if (!sessionId) {
    return null;
  }

  return (
    <div style={{ textAlign: "center", padding: "5rem" }}>
      <h1>Payment Successful</h1>
      <p>Your payment has been processed successfully.</p>
      <p>Session ID: {sessionId}</p>
      <Link to="/market" className="m-2 btn btn-primary">
        Browse Market!
      </Link>
    </div>
  );
}
